module.exports = __webpack_public_path__ + "media/images/athletes/500-8cde633705538202effef46b9aeab9c1.png";